/**
 * This is just a placeholder for direct integrations.
 *
 * @todo: remove this when direct integrations do not use 'error-tracker' anymore
 */
function ErrorTracker() {
    this.logException = emptyImplementation;
    this.logMessage = emptyImplementation;
    this.setContext = emptyImplementation;
}

function emptyImplementation(subject, optionalData, doneCb) {
    typeof doneCb === 'function' ? doneCb() : undefined;
}

export default ErrorTracker;
